import { render, staticRenderFns } from "./HistoryDialogWO.vue?vue&type=template&id=b6b57fca&scoped=true&"
import script from "./HistoryDialogWO.vue?vue&type=script&lang=js&"
export * from "./HistoryDialogWO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b57fca",
  null
  
)

export default component.exports